var path = '/modules/wallets/templates/views/pages/details.tpl.html';
var html = "<h1>{{vm.template.name}}</h1>\n\n<al-wallet-template-editor\n        wallet-template-id=\"vm.stateParams.id\"\n        cancel-trigger=\"vm.editorCancelTrigger\"\n        on-cancel=\"vm.handleCancel()\"\n        on-save-success=\"vm.handleSaveSuccess()\"></al-wallet-template-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/wallets/templates/views/pages/details.tpl.html
// module id = 2179
// module chunks = 1